import Dashboard from "../Views/Dashboard/Dashboard.vue";
import {MODULES} from "../Constants/modules.js";

export const dashboardRoutes = [
    {
        path: "/",
        name: "dashboard",
        component: Dashboard,
        meta: {
            module: MODULES.DASHBOARD,
            menu: {
                parent: 'dashboard',
                child: null
            },
            breadcrumb: {
                title: "Dashboard",
                nav: {
                    all: {
                        active: "Dashboard",
                        inactive: []
                    }
                }
            }
        },
    },
];
